import { ref } from 'vue'
import { useNotificationStore } from '@/stores/notification'

export function useCampanhaFilters() {
  const notificationStore = useNotificationStore()

  // Opções dos filtros
  const diasFiltroOptions = [
    { label: 'igual (exatamente X dias)', value: 'igual' },
    { label: 'maior (> X dias)', value: 'maior' },
    { label: 'menor (< X dias)', value: 'menor' },
    { label: 'vence em até (de hoje até X dias)', value: 'vence_em_ate' },
    { label: 'ja venceu há (vencido há mais de X dias)', value: 'ja_venceu_mais_que' }
  ]

  // Opções de estados brasileiros
  const estadosOptions = [
    { title: 'Acre', value: 'AC' },
    { title: 'Alagoas', value: 'AL' },
    { title: 'Amapá', value: 'AP' },
    { title: 'Amazonas', value: 'AM' },
    { title: 'Bahia', value: 'BA' },
    { title: 'Ceará', value: 'CE' },
    { title: 'Distrito Federal', value: 'DF' },
    { title: 'Espírito Santo', value: 'ES' },
    { title: 'Goiás', value: 'GO' },
    { title: 'Maranhão', value: 'MA' },
    { title: 'Mato Grosso', value: 'MT' },
    { title: 'Mato Grosso do Sul', value: 'MS' },
    { title: 'Minas Gerais', value: 'MG' },
    { title: 'Pará', value: 'PA' },
    { title: 'Paraíba', value: 'PB' },
    { title: 'Paraná', value: 'PR' },
    { title: 'Pernambuco', value: 'PE' },
    { title: 'Piauí', value: 'PI' },
    { title: 'Rio de Janeiro', value: 'RJ' },
    { title: 'Rio Grande do Norte', value: 'RN' },
    { title: 'Rio Grande do Sul', value: 'RS' },
    { title: 'Rondônia', value: 'RO' },
    { title: 'Roraima', value: 'RR' },
    { title: 'Santa Catarina', value: 'SC' },
    { title: 'São Paulo', value: 'SP' },
    { title: 'Sergipe', value: 'SE' },
    { title: 'Tocantins', value: 'TO' }
  ]

  // Regras de validação
  const phoneRules = [
    v => !v || /^\(\d{2}\) \d{5}-\d{4}$/.test(v) || 'Número de telefone inválido'
  ]

  // Estado dos diálogos de confirmação
  const confirmDialog = ref(false)
  const confirmationMessage = ref('')
  const pendingFilters = ref(null)
  const pendingCount = ref(0)

  // Função para validar filtros básicos
  const validateBasicFilters = (form) => {
    // Pelo menos um filtro deve ser preenchido
    const hasFilter = !!(
      form.data_inicio ||
      form.data_fim ||
      form.cidade ||
      form.estados.length > 0 ||
      form.dias_vencimento ||
      form.dias_vencimento_filtro ||
      form.telefone ||
      form.nunca_comprou
    )

    if (!hasFilter) {
      notificationStore.showNotification('Preencha pelo menos um filtro para enviar a campanha.', 'warning')
      return false
    }

    // Validação de intervalo de datas
    if (form.data_inicio && form.data_fim) {
      if (new Date(form.data_fim) < new Date(form.data_inicio)) {
        notificationStore.showNotification('A data final não pode ser anterior à data inicial.', 'warning')
        return false
      }
    }

    // Validação do telefone
    if (form.telefone && !/^\(\d{2}\) \d{5}-\d{4}$/.test(form.telefone)) {
      notificationStore.showNotification('Informe um número de telefone válido.', 'warning')
      return false
    }

    // Validação dos dias de vencimento
    if (form.dias_vencimento !== '' && form.dias_vencimento !== null && form.dias_vencimento !== undefined) {
      const parsed = Number(form.dias_vencimento)
      if (!Number.isInteger(parsed) || parsed < 0) {
        notificationStore.showNotification('Informe um número inteiro maior ou igual a 0 para os dias.', 'warning')
        return false
      }

      if (!form.dias_vencimento_filtro) {
        notificationStore.showNotification('Selecione o tipo de filtro para os dias (igual, maior, menor, ...).', 'warning')
        return false
      }
    }

    return true
  }

  // Função para construir objeto de filtros
  const buildFilters = (form) => {
    const filters = {
      data_inicio: form.data_inicio || undefined,
      data_fim: form.data_fim || undefined,
      cidade: form.cidade || undefined,
      estados: form.estados.length > 0 ? form.estados.join(',') : undefined,
      dias_vencimento: (form.dias_vencimento !== '' && form.dias_vencimento !== null)
        ? Number(form.dias_vencimento)
        : undefined,
      dias_vencimento_filtro: form.dias_vencimento_filtro || undefined,
      telefone: form.telefone || undefined
    }

    if (form.nunca_comprou) {
      filters.nunca_comprou = true
    }

    return filters
  }

  // Função para limpar formulário básico
  const clearBasicForm = (form) => {
    form.data_inicio = ''
    form.data_fim = ''
    form.cidade = ''
    form.estados = []
    form.dias_vencimento = ''
    form.dias_vencimento_filtro = ''
    form.telefone = ''
    form.nunca_comprou = false
    pendingFilters.value = null
    pendingCount.value = 0
  }

  // Função para preparar confirmação
  const prepareConfirmation = (campaignName, count) => {
    confirmationMessage.value = count > 1
      ? `Encontrados ${count} clientes elegíveis.\nDeseja enviar a campanha para eles?`
      : `Encontrado 1 cliente elegível com os filtros informados.\nDeseja enviar a campanha?`
    confirmDialog.value = true
  }

  return {
    // Opções
    diasFiltroOptions,
    estadosOptions,
    phoneRules,

    // Estado dos diálogos
    confirmDialog,
    confirmationMessage,
    pendingFilters,
    pendingCount,

    // Funções utilitárias
    validateBasicFilters,
    buildFilters,
    clearBasicForm,
    prepareConfirmation
  }
}
